import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './components/layout/layout.component';
import {StoreEditorRouting} from '@app/feature/store-editor/store-editor-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormsModule} from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { SelectProductsComponent } from './components/select-products/select-products.component';
import { CTAComponent } from './components/cta/cta.component';
import { CTASettingComponent } from './components-settings/cta-setting/cta-setting.component';
import { TEXTComponent } from './components/text/text.component';
import { COUNTDOWNComponent } from './components/countdown/countdown.component';
import { SLIDERComponent } from './components/slider/slider.component';
import { TESIMONIALComponent } from './components/tesimonial/tesimonial.component';
import { ALERTComponent } from './components/alert/alert.component';
import { FEATUREDPRODUCTSComponent } from './components/featured-products/featured-products.component';
import { AlertSettingComponent } from './components-settings/alert-setting/alert-setting.component';
import { CountdownSettingComponent } from './components-settings/countdown-setting/countdown-setting.component';
import { FeaturedProductsSettingComponent } from './components-settings/featured-products-setting/featured-products-setting.component';
import { SliderSettingComponent } from './components-settings/slider-setting/slider-setting.component';
import { TestimonialSettingComponent } from './components-settings/testimonial-setting/testimonial-setting.component';
import { HeaderSettingComponent } from './components-settings/header-setting/header-setting.component';
import { FooterSettingComponent } from './components-settings/footer-setting/footer-setting.component';
import { PageSettingComponent } from './components-settings/page-setting/page-setting.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import {SharedModule} from '@app/shared/shared.module';
import { TextSettingComponent } from './components-settings/text-setting/text-setting.component';
import { SpacingSettingComponent } from './components-settings/spacing-setting/spacing-setting.component';
import { SubLayoutSettingComponent } from './components-settings/sub-layout-setting/sub-layout-setting.component';
import { SubComponentContainerComponent } from './components/sub-component-container/sub-component-container.component';
import { SubWindowTextComponent } from './components-settings/sub-window-text/sub-window-text.component';
import { VideoSettingComponent } from './components-settings/video-setting/video-setting.component';
import {VideoComponent} from '@app/feature/store-editor/components/video/video.component';
//import 'froala-editor/js/plugins.pkgd.min.js'; 
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MaterialModule } from '@app/material/material.module';
import { NgxMaskDirective } from 'ngx-mask';
@NgModule({
  declarations: [
    LayoutComponent, 
    CTAComponent,
    TEXTComponent, 
    COUNTDOWNComponent, 
    SLIDERComponent, 
    TESIMONIALComponent, 
    ALERTComponent,
    FEATUREDPRODUCTSComponent, 
    HeaderComponent,
    FooterComponent,
    SubComponentContainerComponent, 
    VideoComponent, 
    SelectProductsComponent,
    SpacingSettingComponent,
    SubLayoutSettingComponent,
    SubWindowTextComponent,
    VideoSettingComponent,
    TextSettingComponent,
    CountdownSettingComponent,
    FeaturedProductsSettingComponent, 
    SliderSettingComponent,
    TestimonialSettingComponent,
    HeaderSettingComponent, 
    FooterSettingComponent, 
    PageSettingComponent,
    AlertSettingComponent,
    CTASettingComponent,



  ],
  imports: [
    CommonModule,
    MaterialModule,
    StoreEditorRouting,
    MatFormFieldModule,
    MatInputModule,
    ColorPickerModule,
    FormsModule,
    MatButtonModule,
    MatSliderModule,
    MatDatepickerModule,
    DragDropModule,
    MatCheckboxModule,
    MatDialogModule,
    SharedModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    AngularEditorModule,
    NgxMaskDirective
   // FroalaEditorModule.forRoot(),
  //  FroalaViewModule.forRoot(),
    

    ],
  exports: [
    ALERTComponent,
    COUNTDOWNComponent,
    FEATUREDPRODUCTSComponent,
    TESIMONIALComponent,
    SLIDERComponent,
    TEXTComponent,
    CTAComponent,
    HeaderComponent,
    FooterComponent,
    VideoComponent,
    SelectProductsComponent, 
  ]
})
export class StoreEditorModule { }
